import {
  HEADING_DEFINITIONS,
  isNodeEmpty,
  Placeholder,
} from '@xing-com/content-editor-plugin-helpers';

const Heading = ({ className, level, HEADING_TAG, ...attributes }) => {
  const RenderLeaf = ({
    element,
    children,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === HEADING_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;
      const H = HEADING_TAG || `h${element.data.level}`;

      if (level === element.data.level) {
        if (placeholder && isNodeEmpty(element)) {
          return (
            <H
              {...restOfAttributes}
              {...elementAttributes}
              className={className}
              data-editor-plugin={H}
            >
              {Placeholder(children, className, placeholder)}
            </H>
          );
        }
        return (
          <H
            {...restOfAttributes}
            {...elementAttributes}
            className={className}
            data-editor-plugin={H}
          >
            {children}
          </H>
        );
      }
    }
  };
  return RenderLeaf;
};

export { Heading };
